import http from "@/shared/services/http";

export const listExpensePickingList = (params: any) => http.get(`v1/revenue-expenditures`, { params });
export const deleteExpensePickingList = (id: number) => http.delete(`v1/revenue-expenditures/${id}`);
export const confirmExpensePickingList = (id: number) => http.get(`v1/revenue-expenditures/confirm-debt/${id}`);
export const confirmExpenseCustomerPickingList = (id: number) => http.get(`v1/revenue-expenditures/confirm-customer/${id}`);
export const confirmExpenseEmployeePickingList = (id: number) => http.get(`v1/revenue-expenditures/confirm-customer/${id}`);
